import { Injectable } from '@angular/core'
import { BehaviorSubject, Observable, of } from 'rxjs'
import { catchError } from 'rxjs/operators'
import { SessionStorageKeys } from 'src/app/shared/constants/session-storage-keys'
import { StorageKeys } from 'src/app/shared/constants/storage-keys'
import { supportedLanguagesOnly } from 'src/app/shared/helpers/language'
import { Language } from 'src/app/shared/models/language'

import { ApiService } from '../http/api.service'
import { LocalStorageService } from '../storage/local-storage.service'
import { SessionStorageService } from '../storage/session-storage.service'

@Injectable({
  providedIn: 'root'
})
export class LanguageService {
  constructor(
    private readonly storage: LocalStorageService,
    private sessionStorage: SessionStorageService,
    private readonly api: ApiService
  ) {}
  private associatedContents = []
  private subject = new BehaviorSubject<boolean>(false)
  private languageSubject = new BehaviorSubject<any>(this.sessionStorage.get(SessionStorageKeys.selectedLanguage))

  //msessage:true menas it will freeze otherwise it will unfreeze
  public freezeLanguage(message: boolean) {
    this.subject.next(message)
  }

  public unFreezeLanguage(): Observable<boolean> {
    return this.subject.asObservable()
  }

  public setSelectedLanguage(language: any) {
    this.languageSubject.next(language)
  }

  public getSelectedLanguage(): Observable<any> {
    return this.languageSubject.asObservable()
  }

  public getAssociatedContents() {
    return this.associatedContents
  }

  public setAssociatedContents(inputContents) {
    this.associatedContents = inputContents
  }

  getLanguages() {
    return this.api
      .sendRequest({
        method: 'get',
        endpoint: 'languages'
      })
      .pipe(
        supportedLanguagesOnly(),
        catchError(() => {
          return of([])
        })
      )
  }

  setLangTextDirection(contentData) {
    const languages = this.storage.get(StorageKeys.languages) as Language[]
    if (!languages || (Array.isArray(languages) && languages.length === 0)) {
      this.getLanguages()
        .toPromise()
        .then(langResp => {
          if (langResp) {
            this.storage.set(StorageKeys.languages, langResp)
            return this.getLangDirFromList(langResp, contentData.languageId)
          }
        })
        .catch(() => 'ltr')
    } else {
      return this.getLangDirFromList(languages, contentData.languageId)
    }
  }

  getLangDirFromList(languageList, languageId) {
    if (languageId) {
      const lang = languageList.find(x => x.id == languageId)
      return lang ? (lang.isLeftToRight ? 'ltr' : 'rtl') : 'ltr'
    } else {
      const masterlang = languageList.find(x => x.isMasterEntry)
      return masterlang ? (masterlang.isLeftToRight ? 'ltr' : 'rtl') : 'ltr'
    }
  }

  saveDefaultSettings(body: { languageMasterId?: string; departmentId?: string }) {
    body['source'] = 'ADMIN_UI'
    return this.api.sendRequest({
      method: 'patch',
      endpoint: 'api/v2/company/settings',
      body
    })
  }
}
